import { render } from "./ViewRejectedSpeakersModal.vue?vue&type=template&id=44ab7240"
import script from "./ViewRejectedSpeakersModal.vue?vue&type=script&lang=js"
export * from "./ViewRejectedSpeakersModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__